import { render, staticRenderFns } from "./arrEars.vue?vue&type=template&id=0ab89414&scoped=true"
import script from "./arrEars.vue?vue&type=script&lang=js"
export * from "./arrEars.vue?vue&type=script&lang=js"
import style0 from "./arrEars.vue?vue&type=style&index=0&id=0ab89414&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab89414",
  null
  
)

export default component.exports